import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import {ConfigService, TitleService} from './_services';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: [
      './app.component.scss',
      '../../node_modules/ngx-toasta/styles/style-default.css',
      '../../node_modules/ngx-toasta/styles/style-material.css',
      '../../node_modules/ngx-toasta/styles/style-bootstrap.css'
  ],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  constructor(@Inject(DOCUMENT) private document: Document,
              private router: Router,
              private config: ConfigService,
              private title: TitleService) { }

  ngOnInit(): void {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);

      this.config.getConfig().subscribe((cfg) => {
          const themeName = 'theme' + cfg.themeNo;
          this.document.body.setAttribute('themebg-pattern', themeName);

          this.title.setBaseTitle(cfg.instanceName);
      });
    });
  }
}
